import {
  SET_PRIMARY_INFO,
  CLEAR_PRIMARY_INFO,
  SET_DISPLAY_PHOTO,
  ADD_CARD_DETAILS,
  SET_ACCOUNT_STATUS,
  DISPLAY_PROFILE_MODAL,
  SET_PROFILE_MODAL_PAGE,
  SET_PROFILE_MODAL_DETAIL_PAGE,
  SET_NOTIFICATION_COUNT,
  SET_EMAIL_VERIFICATION_STATUS,
  SET_FAVORITE_MALLS,
  SET_TRANSPORTATION_MALL,
  SET_PREFERENCE_IDS,
  SET_SURVEY_MODAL_STATUS,
  // TODO: import action types added later
} from './types'

function setPrimaryInfo(primaryInfo) {
  return {
    type: SET_PRIMARY_INFO,
    payload: {
      primaryInfo,
    },
  }
}
function clearPrimaryInfo() {
  return {
    type: CLEAR_PRIMARY_INFO,
  }
}
function setDisplayPhoto(displayPhoto) {
  return {
    type: SET_DISPLAY_PHOTO,
    payload: {
      displayPhoto,
    },
  }
}
function setPreferenceIds(ids) {
  return {
    type: SET_PREFERENCE_IDS,
    payload: {
      ids,
    },
  }
}
function setCardAdded(cardsAdded) {
  return {
    type: ADD_CARD_DETAILS,
    payload: {
      cardsAdded,
    },
  }
}
function setAccountStatus(advanceAccount) {
  return {
    type: SET_ACCOUNT_STATUS,
    payload: {
      advanceAccount,
    },
  }
}
function displayProfileModal(showProfileModal) {
  return {
    type: DISPLAY_PROFILE_MODAL,
    payload: {
      showProfileModal,
    },
  }
}
function setProfileModalPage(profileModalPage) {
  return {
    type: SET_PROFILE_MODAL_PAGE,
    payload: {
      profileModalPage,
    },
  }
}
function setProfileModalDetailPage(profileDetailPage) {
  return {
    type: SET_PROFILE_MODAL_DETAIL_PAGE,
    payload: {
      profileDetailPage,
    },
  }
}
function setNotificationCount(notificationCount) {
  return {
    type: SET_NOTIFICATION_COUNT,
    payload: {
      notificationCount,
    },
  }
}
function setEmailVerificationStatus(emailVerificationStatus) {
  return {
    type: SET_EMAIL_VERIFICATION_STATUS,
    payload: {
      emailVerificationStatus,
    },
  }
}
function setFavoriteMalls(favoriteMalls) {
  return {
    type: SET_FAVORITE_MALLS,
    payload: {
      favoriteMalls,
    },
  }
}
function setTransportationMall(transportationMall) {
  return {
    type: SET_TRANSPORTATION_MALL,
    payload: {
      transportationMall,
    },
  }
}
function setSurveyModalStatus(surveyModalStatus) {
  return {
    type: SET_SURVEY_MODAL_STATUS,
    payload: {
      surveyModalStatus,
    },
  }
}
// TODO: add more action creators

export {
  setPrimaryInfo,
  clearPrimaryInfo,
  setDisplayPhoto,
  setPreferenceIds,
  setCardAdded,
  setAccountStatus,
  displayProfileModal,
  setProfileModalPage,
  setProfileModalDetailPage,
  setNotificationCount,
  setEmailVerificationStatus,
  setFavoriteMalls,
  setTransportationMall,
  setSurveyModalStatus,
  // TODO: export action creators added later
}
